import type { ReactElement } from "react";
import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
interface PortalProps {
    children?: ReactElement;
    container?: Element | (() => Element) | null;
    disabled?: boolean;
}
function getPortalContainer(container: PortalProps["container"]) {
    if (typeof container === "function") {
        return container();
    }
    return container ?? document.body;
}
export function Portal(props: PortalProps) {
    const [container, setContainer] = useState(getPortalContainer(props.container));
    useEffect(() => {
        setContainer(() => getPortalContainer(props.container));
    }, [props.container]);
    if (props.disabled) {
        return <>{props.children}</>;
    }
    return <>{createPortal(props.children, container)}</>;
}
